import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    {/*
      TÜM SAĞLAYICILARI BURADA TOPLUYORUZ.
      Bu, en güvenilir yapıdır.
    */}
    <Suspense fallback="Yükleniyor...">
      <I18nextProvider i18n={i18n}>
        <App />
      </I18nextProvider>
    </Suspense>
  </React.StrictMode>
);

// DÜZELTME: Service Worker'ı manuel olarak kaydeden kod bloğu
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('Service Worker başarıyla kaydedildi:', registration);
      })
      .catch(error => {
        console.error('Service Worker kaydı başarısız oldu:', error);
      });
  });
}